import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useNavigate } from "react-router-dom";
import { getStoreLocalData, getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import { formatDate } from "../../../constants/DateUtil/DateUtil";
import { getBrandAppService } from "../../../services/BrandAppServices";
import {
  getBrandOffer,
  getBrandOfferItem,
} from "../../../services/OfferManagements/OfferManagementConfig";
import { getBrandPriceCode } from "../../../services/StorePriceCode/getPriceCode";
import AdminMenu from "../../AdminMenu";

const OffersManagement = () => {
  const navigate = useNavigate();
  const [offersData, setOffersData] = useState([]);
  const [offersItemData, setOffersItemData] = useState([]);

  const [visible, setVisible] = useState(false);

  const { brandProfileData } = getUserData();
  const { storeLocalData } = getStoreLocalData();
  let brandId = brandProfileData.id;
  let enabledGarmentProcessStageBrand =
    brandProfileData.enabledGarmentProcessStage;
  const [loading, setLoading] = useState(false);

  const [appServiceList, setAppServiceList] = useState([]);

  const fetchOfferManagementData = async () => {
    setLoading(true);
    try {
      const appServiceResponse = await getBrandAppService(brandId);
      if (!appServiceResponse.data.error) {
        const appServices = appServiceResponse.data;
        setAppServiceList(appServices);

        const brandPriceCodeResponse = await getBrandPriceCode(brandId);
        if (!brandPriceCodeResponse.data.error) {
          const brandPriceCodes = brandPriceCodeResponse.data.prices;

          const response = await getBrandOffer(brandId);
          if (!response.data.error) {
            const offers = response.data;

            // Create a map for quick lookup of priceCodes by their id
            const priceCodeMap = brandPriceCodes.reduce((map, priceCode) => {
              map[priceCode.id] = priceCode.priceCode;
              return map;
            }, {});

            // Add priceCode to offers if priceId exists
            const offersWithPriceCodes = offers.map((offer) => {
              if (offer.priceId !== null) {
                return { ...offer, priceCode: priceCodeMap[offer.priceId] };
              }
              return offer;
            });

            setOffersData(offersWithPriceCodes);

            const items = await Promise.all(
              offersWithPriceCodes.map(async (offer) => {
                const itemResponse = await getBrandOfferItem(brandId, offer.id);
                if (!itemResponse.data.error) {
                  return {
                    offerId: offer.id,
                    items: itemResponse.data.map((item) => {
                      const appService = appServices.find(
                        (service) => service.appService.id === item.itemId
                      );
                      return {
                        ...item,
                        appServiceName: appService
                          ? appService.appService.name
                          : "",
                      };
                    }),
                  };
                } else {
                  return {
                    offerId: offer.id,
                    items: [],
                  };
                }
              })
            );

            const offersItemData = items.reduce((acc, curr) => {
              acc[curr.offerId] = curr.items;
              return acc;
            }, {});
            setOffersItemData(offersItemData);
            setLoading(false);
          }
        }
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  useEffect(() => {
    fetchOfferManagementData();
  }, []);

  const renderCardItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Name :
                  </p>
                  <p className="text-lg font-medium capitalize">{item.name}</p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Offer Category :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.offerCategory.name}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Offer Type :
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {item.offerType.name}{" "}
                      {item.offerType.name === "AMOUNT" ? "(" +  storeLocalData?.currencySymbol + ")" : "(%)"}
                    </p>
                  </div>
                  <div
                    className="mr-4 mt-2"
                    onClick={() =>
                      navigate("/OffersManagementCreate", {
                        state: {
                          id: item.id,
                        },
                      })
                    }
                  >
                    <i
                      className="pi pi-pencil"
                      style={{
                        fontSize: "25px",
                        cursor: "pointer",
                        color: "#2B70D7",
                      }}
                    ></i>
                  </div>
                </div>
              </div>
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Status:
                  </p>

                  {item.status === "ACTIVE" ? (
                    <div className="flex">
                      <p className="text-lg font-medium capitalize">Active </p>
                      <img
                        src={
                          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                        }
                      />
                    </div>
                  ) : (
                    <div>
                      <p className="text-lg font-medium capitalize">
                        DeActive{" "}
                      </p>
                      <img
                        src={
                          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                        }
                      />
                    </div>
                  )}
                </div>
                <div
                  className=" px-3 py-1"
                  style={{
                    flex: 1,
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Valid From :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {formatDate(item.validFrom)} - {formatDate(item.validTo)}
                  </p>
                </div>
                <div
                  className=" px-3 py-1"
                  style={{
                    flex: 1,
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Value :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.offerType.name === "AMOUNT"
                      ?  storeLocalData?.currencySymbol + " " + item.value
                      : item.value + " %"}
                  </p>
                </div>
              </div>
              {offersItemData[item.id] && offersItemData[item.id].length > 0 && (
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    App Service :
                  </p>
                  <p className="text-lg font-medium capitalize"> {offersItemData[item.id]
                    .map(offerItem => offerItem.appServiceName)
                    .join(', ')}</p>
                </div>
                </div>
              )}
              {item.offerCategory.name === 'GARMENT' && (
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Tariff Code :
                  </p>
                  <p className="text-lg font-medium capitalize"> {item.priceCode}</p>
                </div>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Offer Management
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div
          className="flex-1  surface-0"
          style={{ "--surface-0": "#EAEFF5" }}
        >
          <div className="flex justify-content-between mx-4">
            <div className="py-1">
              <p className=" text-2xl  font-bold ">CREATE OFFERS</p>
            </div>
            <div
              className="flex justify-content-center align-items-center cursor-pointer mr-4"
              onClick={() => {
                navigate("/OffersManagementCreate", {
                  state: {
                    id: null,
                  },
                });
              }}
            >
              <img src="images/plus.png" alt="plus" style={{ width: 30 }} />
            </div>
          </div>
        </div>
      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : offersData?.length > 0 ? (
          <div>            
            <div>{renderCardItem(offersData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Offer Found</p>
          </div>
        )}
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default OffersManagement;
